import firebase from "../redux/store";
import moment from "moment";
const firestore = firebase.firestore();
// const jsQR = require("jsqr");
const serviceUrl = "https://api.maprinter.com/service";

const storage = firebase.storage();

const helpers = {
  getPrinterByQRCode: (code) => {
    return new Promise(async (resolve, reject) => {
      let snapshot = await firestore.collection("qrcodes").doc(code).get();
      if (snapshot.exists) {
        resolve(snapshot.data().printer);
      } else {
        reject();
      }
    });
  },
  getPrinter: (printer) => {
    return new Promise(async (resolve, reject) => {
      let snapshot = await printer.get();
      let data = snapshot.data();
      data.snapshot = snapshot;
      resolve(data);
    });
  },
  getFile: (fileKey) => {
    return new Promise(async (resolve, reject) => {
      let snapshot = await firestore.doc(`documents/${fileKey}`).get();
      let data = snapshot.data();
      data.snapshot = snapshot;
      resolve(data);
    });
  },
  getMFPResponse: (printer, serviceRef, id) => {
    return new Promise((resolve, reject) => {
      let serviceRefListener = firestore
        .doc(serviceRef)
        .onSnapshot((snapshot) => {
          let data = snapshot.data();
          if (data.progress && data.progress.id == id && data.request) {
            let pages = 0;
            switch (data.request.action) {
              case "scan":
                if (!data.request.copy) pages = data.progress.scans;
                break;
              case "print":
              case "copy":
                pages = data.progress.prints;
                break;
            }
            $("#ring-progress").text(pages);
          }
          if (data.response && data.response.id == id) {
            console.log(printer.state.print);
            if (printer.state.print || printer.state.copy) {
              console.log("resolve");
              serviceRefListener();
              resolve();
            } else {
              if (data.response.file) {
                serviceRefListener();
                resolve(data.response.file);
              }
            }
          }
        });
    });
  },
  putObject: (signedUrl, file, uploadProgress) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = (evt) => {
        $.ajax({
          xhr: () => {
            const xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener(
              "progress",
              function (evt) {
                if (evt.lengthComputable) {
                  const percentComplete = Math.round(
                    (evt.loaded / evt.total) * 100
                  );
                  uploadProgress(percentComplete);
                }
              },
              false
            );
            return xhr;
          },
          method: "PUT",
          url: signedUrl,
          data: Buffer.from(evt.target.result),
          contentType: "binary/octet-stream",
          processData: false,
          error: (e) => {
            console.log(e.statusCode);
          },
          success: async (response) => {
            resolve();
          },
        });
      };

      reader.onerror = (err) => {
        console.log(err);
        console.log(err.target.error);
        reject(err);
      };
    });
  },
  getDocument(fileKey) {
    return new Promise(async (resolve, reject) => {
      let snapshot = await firestore.doc(`documents/${fileKey}`).get();
      let data = snapshot.data();
      data.snapshot = snapshot;
      resolve(data);
    });
  },
  getFile(file) {
    return new Promise(async (resolve, reject) => {
      const snapshot = await file.get();
      let data = snapshot.data();
      if (data) {
        const thumbnail = await helpers.serviceRequest("downloadPdf", {
          key: data.thumbnail,
        });
        data.thumbnail = thumbnail.presigned_url;
        data.id = snapshot.id;
        data.path = snapshot.ref.path;
        resolve(data);
      } else {
        console.log("file not exists");
        await this.removeFileFromUser({
          file: file.path,
          userRef: firestore
            .collection("clients")
            .doc(firebase.auth().currentUser.uid),
        });
        resolve();
      }
    });
  },
  getFiles(files) {
    return new Promise(async (resolve, reject) => {
      if (files) {
        let promises = [];
        for (let file of files) promises.push(this.getFile(file));
        const filesPromised = await Promise.all(promises);
        const recentFiles = filesPromised.filter((el) => el != null && moment(el.timestamp).isSameOrAfter(moment().subtract(7, 'days')));
        const outdatedFiles = filesPromised.filter((el) => el != null && moment(el.timestamp).isBefore(moment().subtract(7, 'days')));
        await Promise.all(outdatedFiles.map((file) => this.removeFileFromUser({
          file: file.path,
          userRef: firestore
            .collection("clients")
            .doc(firebase.auth().currentUser.uid),
        })));
        resolve(recentFiles);
      }
    });
  },
  addFileToUser: (params) => {
    return new Promise(async (resolve, reject) => {
      await params.userRef.update({
        files: firebase.firestore.FieldValue.arrayUnion(
          firestore.doc(`documents/${params.file}`)
        ),
      });
      resolve();
    });
  },
  removeFileFromUser: (params) => {
    return new Promise(async (resolve, reject) => {
      const docRef = firestore.doc(`${params.file.replace(".pdf", "")}`);
      params.userRef.update({
        files: firebase.firestore.FieldValue.arrayRemove(docRef),
      });
      resolve();
    });
  },
  serviceRequest: (request, data) => {
    return new Promise(async (resolve, reject) => {
      $.ajax({
        url: `${serviceUrl}?request=${request}&${new URLSearchParams(
          data
        ).toString()}`,
        type: "post",
        data: JSON.stringify(data),
        dataType: "json",
        success: async (response) => {
          // Check for API-level errors
          if (response && response.success === false) {
            reject(response);
          } else {
            resolve(response);
          }
        },
        error: (xhr, status, error) => {
          // Try to parse error response if available
          let errorResponse = error;
          try {
            if (xhr.responseJSON) {
              errorResponse = xhr.responseJSON;
            } else if (xhr.responseText) {
              errorResponse = JSON.parse(xhr.responseText);
            }
          } catch (e) {
            // If parsing fails, use the original error
            console.log("Failed to parse error response:", e);
          }
          reject(errorResponse || error);
        },
      });
    });
  },
  getPathFromUrl: (url) => {
    return new URL(url).pathname.substr(1);
  },
  b64toBlob: (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  },
  sanitizeName: (name) => {
    const exclusions = ["undefined"];
    for (const exclusion of exclusions) {
      name = name.replace(new RegExp(exclusion, "g"), "");
    }

    const withoutDuplications = name
      .split(" ")
      .filter(
        (item, i, allItems) =>
          i ==
          allItems.map((item) => item.toLowerCase()).indexOf(item.toLowerCase())
      );

    const firstWordWithNumberIndex =
      withoutDuplications.findIndex((word) => /\d/.test(word)) + 1;

    const filteredName = withoutDuplications
      .slice(0, firstWordWithNumberIndex)
      .join(" ")
      .replace(/\s\s+/g, " ")
      .trim();

    return filteredName;
  },
  downloadPic: (printer) => {
    return new Promise(async (resolve, reject) => {
      printer = printer.props.printer;
      let filename = `${printer.manufacturer} ${printer.model}`.replace(
        /\//g,
        "|"
      );
      filename = helpers.sanitizeName(filename);
      storage
        .ref(`images/mfp/${filename}.png`)
        .getDownloadURL()
        .then(function (url) {
          resolve(url);
        });
    });
  },
  getUrlParameter: (sParam, url) => {
    let link = url ? new URL(url) : window.location;
    let sPageURL = link.search.substring(1);
    let sURLVariables = sPageURL.split("&");
    let sParameterName, i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
  },
  activateMenu: (menuData) => {
    $(".menu").removeClass("menu-active");
    $(".menu-hider").addClass("menu-active");
    let menu = menuData.currentTarget
      ? $(`#${$(menuData.currentTarget).data("menu")}`)
      : $(`#${menuData}`);
    menu.hasClass("menu-active")
      ? menu.removeClass("menu-active")
      : menu.addClass("menu-active");
  },
  closeMenu: () => {
    $(".menu").removeClass("menu-active");
    $(".menu-hider").removeClass("menu-active menu-active-clear");
    $(".header, .page-content, #reading-progress-bar").css(
      "transform",
      "translate(0,0)"
    );
    $(".menu-hider").css("transform", "translate(0,0)");
    return false;
  },
  fixPrinter: (printer) => {
    let printerParsed = printer.parsed;
    if (printerParsed.model != null) {
      if (printerParsed.manufacturer == null) {
        var model = printerParsed.model.split(" ");
        printerParsed.manufacturer = model[0];
        model.shift();
        printerParsed.model = model.join(" ");
      }
      if (printerParsed.serialNumber != null) {
        if (printerParsed.model.indexOf(printerParsed.serialNumber) != -1) {
          printerParsed.model = printerParsed.model
            .replace(printerParsed.serialNumber, "")
            .trim();
        }
      }
      printer.manufacturer = printerParsed.manufacturer;
      printer.model = printerParsed.model
        .replace(/series/gi, "")
        .replace("  ", " ")
        .trim();
    }
    return printer;
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/helpers/index.js